import { Breakpoint, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

type BreakpointType = Breakpoint | number;
type TypeProps = {
  query: 'up' | 'down' | 'between' | 'only';
  key?: BreakpointType;
  start?: BreakpointType;
  end?: BreakpointType;
};

export const useResponsive = ({ query, key, start, end }: TypeProps) => {
  const theme = useTheme();
  const mediaUp = useMediaQuery(theme.breakpoints.up(key as BreakpointType));
  const mediaDown = useMediaQuery(theme.breakpoints.down(key as BreakpointType));
  const mediaBetween = useMediaQuery(
    theme.breakpoints.between(start as BreakpointType, end as BreakpointType)
  );
  const mediaOnly = useMediaQuery(theme.breakpoints.only(key as Breakpoint));

  if (query === 'up') {
    return mediaUp;
  }

  if (query === 'down') {
    return mediaDown;
  }

  if (query === 'between') {
    return mediaBetween;
  }

  if (query === 'only') {
    return mediaOnly;
  }
  return null;
};
